import React, { useEffect, useState } from "react";
import API, { getMediaUrl } from "../services/api";

let cachedLogoUrl = "";
let pendingLogoLoad = null;

function WhatsAppGlyph({ size = 24 }) {
  const [logoUrl, setLogoUrl] = useState(cachedLogoUrl || "/whatsapp-logo.svg");

  useEffect(() => {
    if (cachedLogoUrl) {
      setLogoUrl(cachedLogoUrl);
      return;
    }
    if (!pendingLogoLoad) {
      pendingLogoLoad = API.get("/settings/public")
        .then((res) => {
          cachedLogoUrl = resolveAssetUrl(res.data?.asset_whatsapp_logo_url, "/whatsapp-logo.svg");
          return cachedLogoUrl;
        })
        .catch(() => "/whatsapp-logo.svg");
    }
    pendingLogoLoad.then((url) => setLogoUrl(url || "/whatsapp-logo.svg"));
  }, []);

  return (
    <img
      src={logoUrl}
      width={size}
      height={size}
      alt=""
      aria-hidden="true"
      style={{
        display: "block",
        width: size,
        height: size,
        objectFit: "contain",
        filter: "drop-shadow(0 6px 10px rgba(0,0,0,0.16))",
      }}
      onError={(event) => {
        event.currentTarget.src = "/whatsapp-logo.png";
      }}
    />
  );
}

function resolveAssetUrl(value, fallback) {
  const raw = String(value || fallback || "").trim();
  if (raw.startsWith("/uploads/")) return getMediaUrl(raw);
  return raw || fallback;
}

export default WhatsAppGlyph;
